<template>
    <div :id="'searchable-list-with-file-' + element.id"
         class="h-100 searchable-list-with-file">
        <div class="row m-0 h-100">
            <div v-if="element.data.name || element.data.content"
                 class="text col-12 col-md-9">
                <block-headline
                    v-if="element.data.name"
                    :text="element.data.name"
                    class="text__headline mb-0"></block-headline>
                <div v-if="element.data.content"
                     class="text__content"
                     v-html="element.data.content">
                </div>
            </div>
            <div v-if="element.data.file" class="link col-12 col-md-3">
                <a :href="'/storage' + element.data.file"
                   :title="'Download' + element.data.name"
                   class="link__element"
                   target="_blank">Datei herunterladen <i class="fad fa-download"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchableListElement',
    props: {
        element: null,
    },
};
</script>
